import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { usePointPreview } from '/src/PointPreviewContext';
import ListItemTemplate from './ListItemTemplate';
import { XMarkIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { MapPinIcon } from '@heroicons/react/24/solid';
import { useNavigation } from '/src/NavigationContext';
import { useLocation } from '/src/LocationContext';

const PointPreview = () => {
  const { isPreviewOpen, previewPoint, closePreview, onPreviewAction, onNavigationAction } = usePointPreview();

  const { locationError } = useLocation();

  const { 
    activeRoute,
    nextInstruction, 
    stopNavigation, 
    distanceToNextTurn,
    routeError,
    calculatingRoute
  } = useNavigation();


  if (!isPreviewOpen || !previewPoint) return null;

  const handleAction = () => {
    console.log("handleAction", previewPoint);
    if (onPreviewAction) {
      onPreviewAction(previewPoint);
    }
    closePreview();
  };

  // Extract data needed for ListItemTemplate
  const { 
    title, 
    name, 
    description, 
    image, 
    icon,
    order
  } = previewPoint.data || previewPoint;

  return (
    <div 
      className="bg-white rounded-lg shadow-lg z-50 w-[90%] mx-auto max-w-md overflow-hidden focus:outline-none active:outline-none" 
      onClick={handleAction}
      style={{ WebkitTapHighlightColor: 'transparent' }}
    >        
      <ListItemTemplate 
        title={`${order} - ` + title}
        name={`${order} - ` + name}
        description={(!activeRoute && !routeError) ? description : null}
        image={image?.preview_url || image}
        icon={icon?.preview_url || icon}
        activeRoute={activeRoute}
        preview={true}
      >
        
        {(!activeRoute && !locationError) &&
          <div className="flex justify-between items-center">
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (onNavigationAction) {
                  onNavigationAction(previewPoint);
                }
              }}
              disabled={calculatingRoute}
              className="py-2 px-2 rounded-full bg-green-600 text-sm text-white hover:bg-green-600 flex items-center focus:outline-none active:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <MapPinIcon className="w-4 h-4 mr-1" />
              <div className="text-xs">Start navigatie</div>
            </button>
          </div>
        }

        {routeError && (
          <div className="text-red-600 text-sm py-1">
            Routeberekening mislukt. Probeer opnieuw.
          </div>
        )}

        {(activeRoute) && (
          <>
            <div className="flex items-center justify-between mb-2">
              <div className="flex-1">
                {nextInstruction && (
                  <div>{nextInstruction.text}</div>
                )}
                {distanceToNextTurn !== null && !isNaN(distanceToNextTurn) && (
                  <div className="text-sm text-gray-600">
                    {distanceToNextTurn < 1000 
                      ? `${Math.round(distanceToNextTurn)}m` 
                      : `${(distanceToNextTurn / 1000).toFixed(1)}km`}
                  </div>
                )}
              </div>
            </div>
            
            <div className="flex justify-between items-center">
              <button 
                className="py-2 px-2 rounded-full bg-red-600 text-sm text-white hover:bg-red-700 flex items-center focus:outline-none active:outline-none"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  stopNavigation();
                }}
              >
                <XMarkIcon className="w-4 h-4 mr-1" />
                <div className="text-xs">Stop navigatie</div>
              </button>
            </div>
          </>
        )}

      </ListItemTemplate>
    </div>
  );
};

export default PointPreview; 